import {
    useGetUniqueCampaignsPlatformQuery, useGetSpendBreakdownPlatformQuery,
    useGetClicksCpsBreakdownPlatformQuery, useGetConversionsCpaBreakdownPlatformQuery,
    useConversionsCpaBreakdownTablePlatformQuery, useGetActiveCampaignsQuery
} from "../../redux/api/adsReporting";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Button, Select } from "antd";
import PlotContainer from "../PlotContainer";
import DateGranularityDropdown from "../../components/UI/DateGranularityDropdown";
import TableContainer from "../TableContainer";
import CampaignComparison from "./CampaignComparison";
import PeriodOnPeriodTable from "./PeriodOnPeriodTable";
import TooltipContainer from "../../components/UI/TooltipContainer";

export default function Reporting({ platform }) {

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedStartDate = useSelector((state) => state.genericReporting.selectedDropdownValues['start_date']);
    const selectedEndDate = useSelector((state) => state.genericReporting.selectedDropdownValues['end_date']);
    const granularity = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);

    const [campaignOptions, setCampaignOptions] = useState([]);
    const [selectedCampaigns, setSelectedCampaigns] = useState([]);

    const uniqueCampaigns = useGetUniqueCampaignsPlatformQuery({
        client: selectedClient,
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        platform: platform
    });

    const activeCampaigns = useGetActiveCampaignsQuery({
        client: selectedClient,
        platform: platform
    });

    useEffect(() => {
        if (uniqueCampaigns.status === 'fulfilled' && activeCampaigns.status === 'fulfilled') {
            setCampaignOptions(uniqueCampaigns.data.map(
                (campaign) => {
                    return {
                        label: campaign,
                        value: campaign
                    }
                }

            ));

            var yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);






            yesterday.setHours(0, 0, 0, 0);
            yesterday = yesterday.toISOString().split('T')[0];

            if (selectedEndDate >= yesterday) {
                setSelectedCampaigns(activeCampaigns.data);
            } else {
                setSelectedCampaigns(uniqueCampaigns.data);
            }
        }
        else {
            setCampaignOptions([]);
            setSelectedCampaigns([]);
        }
    }, [uniqueCampaigns, activeCampaigns]);

    return (
        <div>
            <h1>{platform[0].toUpperCase() + platform.slice(1)} Reporting</h1>
            <div className='flexible-container'>
                <h3>Select Campaigns <TooltipContainer title='Select Campaigns'></TooltipContainer></h3>
                <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%', 'marginBottom': '1vh' }}
                    placeholder="Please select"
                    value={selectedCampaigns}
                    onChange={(value) => {
                        setSelectedCampaigns(value);
                    }}
                    options={campaignOptions}
                >
                </Select>
                <Button onClick={
                    () => {
                        setSelectedCampaigns(uniqueCampaigns.data);
                    }
                }>All Campaigns</Button>
                <Button onClick={
                    () => {
                        setSelectedCampaigns(activeCampaigns.data);
                    }
                }>Active Campaigns Only</Button>
                <h3>Select Date Granularity <TooltipContainer title='Date Granularity'></TooltipContainer></h3>
                <DateGranularityDropdown />
            </div>
            <br></br>
            <div className='flexible-container'>
                <div style={{
                    'width': '100%',
                    'height': '80vh'
                }}>
                    <PlotContainer tooltipTitle='Spend Breakdown by Campaign' useApi={useGetSpendBreakdownPlatformQuery} useApiArgs={{
                        client: selectedClient,
                        startDate: selectedStartDate,
                        endDate: selectedEndDate,
                        selectedCampaigns: selectedCampaigns,
                        platform: platform,
                        granularity: granularity
                    }} />
                </div>
            </div>
            <div className="full-width-container">
                <PlotContainer tooltipTitle='Clicks vs CPC' useApi={useGetClicksCpsBreakdownPlatformQuery} useApiArgs={{
                    client: selectedClient,
                    startDate: selectedStartDate,
                    endDate: selectedEndDate,
                    selectedCampaigns: selectedCampaigns,
                    granularity: granularity,
                    platform: platform
                }} />
            </div>
            <div className="full-width-container">
                <PlotContainer tooltipTitle='Conversions vs CPA' useApi={useGetConversionsCpaBreakdownPlatformQuery} useApiArgs={{
                    client: selectedClient,
                    startDate: selectedStartDate,
                    endDate: selectedEndDate,
                    selectedCampaigns: selectedCampaigns,
                    granularity: granularity,
                    platform: platform
                }} />
            </div>
            <CampaignComparison platform={platform} selectedCampaigns={selectedCampaigns} />
            <PeriodOnPeriodTable platform={platform} selectedCampaigns={selectedCampaigns} />
            <TableContainer height={'50vh'} tooltipTitle="Daily Metrics Table" useApi={useConversionsCpaBreakdownTablePlatformQuery} apiParams={{
                client: selectedClient,
                startDate: selectedStartDate,
                endDate: selectedEndDate,
                selectedCampaigns: selectedCampaigns,
                granularity: granularity,
                platform: platform
            }} />
        </div>
    )
}